// extracted by mini-css-extract-plugin
export default {"empty":"styles_empty__PLY3h","empty__row":"styles_empty__row__9TG9a"};